import { createContext } from "react";

// Simple URL type (Node's UrlObject not needed in browser)
type UrlObject = {
  pathname?: string;
  query?: Record<string, string | string[]>;
  hash?: string;
};

type Url = string | UrlObject;

export type LeavePageContextParamsType = {
  push?: Url;
  replace?: Url;
} | null;

type LeavePageInfoContextType = {
  leavePage: LeavePageContextParamsType;
};

type LeavePageContextType = {
  isLeavePage: boolean;
};

type LeavePageModalContextType = {
  isOpen: boolean;
};

type LeavePageActionsContextType = {
  trackLeavePage: () => void;
  setLeavePage: (params: LeavePageContextParamsType) => void;
  untrackLeavePage: () => void;
  openModal: () => void;
  closeModal: () => void;
};

export const LeavePageContext = createContext<LeavePageContextType>({
  isLeavePage: false,
});

export const LeavePageModalContext = createContext<LeavePageModalContextType>({
  isOpen: false,
});

export const LeavePageInfoContext = createContext<LeavePageInfoContextType>({
  leavePage: null,
});

export const LeavePageActionsContext = createContext<LeavePageActionsContextType>({
  trackLeavePage: () => {},
  setLeavePage: () => {},
  untrackLeavePage: () => {},
  openModal: () => {},
  closeModal: () => {},
});
